import BlockButton from "blocks/models/block-button.interface";

export default (locations: BlockButton[], pathname: string) => {
    const result = locations.find(x => x.content.link === pathname);
    return result;
};